export default function () {
  if (this.editing) {
  }
}
